var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid gap-6",class:("grid-cols-" + (_vm.component.attributes.columns)),on:{"click":function($event){return _vm.$emit('select', _vm.component)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }